import React, { useState, useEffect } from 'react';
import { getLevelTitle, getXPProgress } from '../../utils/gamificationManager';
import { playSound } from '../../utils/soundManager';

const XPGainedModal = ({ xpGained, currentLevel, totalXP, onClose, isTimeout = false }) => {
  const [animatedXP, setAnimatedXP] = useState(0);
  const { title, color, icon } = getLevelTitle(currentLevel);
  const progress = getXPProgress(totalXP);

  useEffect(() => {
    if (isTimeout) {
      playSound('incorrect');
    } else {
      playSound('success');
    }
    
    // Animate XP count
    const duration = 1500; // 1.5 seconds
    const steps = 30;
    const increment = xpGained / steps;
    let current = 0;
    
    const timer = setInterval(() => {
      current += increment;
      if (current >= xpGained) {
        setAnimatedXP(xpGained);
        clearInterval(timer);
      } else {
        setAnimatedXP(Math.floor(current));
      }
    }, duration / steps);

    return () => clearInterval(timer);
  }, [xpGained]);

  return (
    <div className="level-up-overlay" onClick={onClose}>
      <div className="level-up-modal xp-gained-modal" onClick={(e) => e.stopPropagation()}>
        {isTimeout ? (
          <>
            <div className="level-up-icon">⏰</div>
            <h1 className="level-up-title" style={{ color: '#e74c3c' }}>
              TIME'S UP!
            </h1>
            <p className="level-up-message">
              Quiz ended due to timeout
            </p>
            
            <div className="xp-gained-display">
              <div className="xp-gained-number" style={{ color: '#e74c3c' }}>
                0 XP
              </div>
              <p style={{ color: 'var(--secondary-text)', marginTop: '1rem' }}>
                Complete the quiz within time to earn XP!
              </p>
            </div>

            <button className="level-up-button" onClick={onClose} style={{ background: '#e74c3c' }}>
              Try Again
            </button>
          </>
        ) : (
          <>
            <div className="level-up-icon">{icon}</div>
            <h1 className="level-up-title" style={{ color }}>
              LEVEL {currentLevel}
            </h1>
            <p className="level-up-message">
              <strong>{title}</strong>
            </p>
            
            <div className="xp-gained-display">
              <div className="xp-gained-number">
                +{animatedXP} XP
              </div>
              <div className="xp-progress-info">
                {progress.currentLevelXP} / {progress.xpNeededForNextLevel} XP
              </div>
            </div>

            <div className="xp-progress-bar">
              <div 
                className="xp-progress-fill" 
                style={{ 
                  width: `${progress.percentage}%`,
                  background: color,
                  transition: 'width 1.5s ease-out'
                }}
              ></div>
            </div>

            <button className="level-up-button" onClick={onClose} style={{ background: color }}>
              Continue
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default XPGainedModal;
